const MODULE_NAME = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration'
const UPDATE_TEST_CONFIG_NAMES = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/UPDATE_TEST_CONFIG_NAMES'
const UPDATE_TEST_LIST = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/UPDATE_TEST_LIST'
const UPDATE_TEST_PROFILES = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/UPDATE_TEST_PROFILES'
const CLEAR_TEST_PROFILES = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/CLEAR_TEST_PROFILES'
const CLEAR_TEST_LIST = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/CLEAR_TEST_LIST'
const CLEAR_TEST_CONFIG_NAMES = 'CLEAR_TEST_CONFIG_NAMES'

const FETCH_TEST_CONFIG = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_CONFIG'
const FETCH_TEST_CONFIG_START = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_CONFIG_START'
const FETCH_TEST_CONFIG_SUCCESS = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_CONFIG_SUCCESS'
const FETCH_TEST_CONFIG_ERROR = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_CONFIG_ERROR'

const FETCH_TEST_PROFILES = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_PROFILES'
const FETCH_TEST_PROFILES_START = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_PROFILES_START'
const FETCH_TEST_PROFILES_SUCCESS = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_PROFILES_SUCCESS'
const FETCH_TEST_PROFILES_ERROR = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/FETCH_TEST_PROFILES_ERROR'

const POST_TEST_CONFIG = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/POST_TEST_CONFIG'
const POST_TEST_CONFIG_START = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/POST_TEST_CONFIG_START'
const POST_TEST_CONFIG_SUCCESS = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/POST_TEST_CONFIG_SUCCESS'
const POST_TEST_CONFIG_ERROR = 'fulcrum/container/Product/FulcrumTestSuiteConfiguration/POST_TEST_CONFIG_ERROR'

export {
  MODULE_NAME,
  FETCH_TEST_CONFIG,
  FETCH_TEST_CONFIG_START,
  FETCH_TEST_CONFIG_SUCCESS,
  FETCH_TEST_CONFIG_ERROR,
  FETCH_TEST_PROFILES,
  FETCH_TEST_PROFILES_START,
  FETCH_TEST_PROFILES_SUCCESS,
  FETCH_TEST_PROFILES_ERROR,
  POST_TEST_CONFIG,
  POST_TEST_CONFIG_START,
  POST_TEST_CONFIG_SUCCESS,
  POST_TEST_CONFIG_ERROR,
  CLEAR_TEST_LIST,
  CLEAR_TEST_PROFILES,
  CLEAR_TEST_CONFIG_NAMES,
  UPDATE_TEST_CONFIG_NAMES,
  UPDATE_TEST_LIST,
  UPDATE_TEST_PROFILES,
}